export default "__VITE_ASSET__59fa5ad2__"